export default __webpack_public_path__ + "static/media/img-5.feb6e033.jpg";